/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type insignGenerateAndRegisterDocumentForSigningInput = {
    clientMutationId?: string | null;
    entitySlug: string;
    entityType: string;
    templateSlug: string;
    folderSlug: string;
    attachmentSlugIds?: Array<string> | null;
    customerType?: string | null;
    language?: string | null;
    email?: string | null;
    customerCountry?: string | null;
    templateList?: Array<string> | null;
};
export type UploadDocumentsWizardGenerateAndSendForSignatureMutationVariables = {
    input: insignGenerateAndRegisterDocumentForSigningInput;
};
export type UploadDocumentsWizardGenerateAndSendForSignatureMutationResponse = {
    readonly insignGenerateAndRegisterDocumentForSigning: {
        readonly clientMutationId: string | null;
        readonly esignLink: string;
    } | null;
};
export type UploadDocumentsWizardGenerateAndSendForSignatureMutation = {
    readonly response: UploadDocumentsWizardGenerateAndSendForSignatureMutationResponse;
    readonly variables: UploadDocumentsWizardGenerateAndSendForSignatureMutationVariables;
};



/*
mutation UploadDocumentsWizardGenerateAndSendForSignatureMutation(
  $input: insignGenerateAndRegisterDocumentForSigningInput!
) {
  insignGenerateAndRegisterDocumentForSigning(input: $input) {
    clientMutationId
    esignLink
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "insignGenerateAndRegisterDocumentForSigningPayload",
    "kind": "LinkedField",
    "name": "insignGenerateAndRegisterDocumentForSigning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "esignLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadDocumentsWizardGenerateAndSendForSignatureMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadDocumentsWizardGenerateAndSendForSignatureMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c66015b0de8ac7bda54f84192bea555b",
    "id": null,
    "metadata": {},
    "name": "UploadDocumentsWizardGenerateAndSendForSignatureMutation",
    "operationKind": "mutation",
    "text": "mutation UploadDocumentsWizardGenerateAndSendForSignatureMutation(\n  $input: insignGenerateAndRegisterDocumentForSigningInput!\n) {\n  insignGenerateAndRegisterDocumentForSigning(input: $input) {\n    clientMutationId\n    esignLink\n  }\n}\n"
  }
};
})();
(node as any).hash = 'dd19f7838039731c0e3e139ed31ceae3';
export default node;
